import React, { useEffect } from "react"

import { useMutation } from "@apollo/react-hooks"
import gql from "graphql-tag"
import Layout from "../layout"
import SEO from "../seo"

import { Container, Section } from "../anti/grid/grid"

import icHome from "../../assets/img/icons/icHome.png"
import icCooper from "../../assets/img/icons/icCooper.png"
import icGlobe from "../../assets/img/icons/ic-globe.png"
import icMIQ from "../../assets/img/icons/ic-miq.png"
import twCircle from "../../assets/img/icons/crxTwitter.png"
import fbCircle from "../../assets/img/icons/crFacebook.png"
import igCircle from "../../assets/img/icons/crInstagram.png"
import youtubeCircle from "../../assets/img/icons/crYoutube.png"
import logoBrand from "../../assets/img/brand/logo_bsd-dark.png"
import linkedinCircle from "../../assets/img/icons/crLinkedin.png"
import icSuistainability from "../../assets/img/icons/icSuistainability.png"
import waIcon from "../../assets/img/icons/iconWA.png"
import csIcon from "../../assets/img/icons/iconCS.png"
import waCircle from "../../assets/img/icons/crWA.png"
import cooperCircle from "../../assets/img/icons/crCooper.webp"
import { hashIP, getIpAddress } from "../../utils/hash"
import { extractSearchParams } from "../../utils/handle-utm"

import "@glidejs/glide/dist/css/glide.core.min.css"
import "@glidejs/glide/dist/css/glide.theme.min.css"

const SUBMIT_GET_PROPERTY_INFO = gql`
  mutation SubmitFormGetPropertyInfo(
    $uniqueIds: String
    $utm: String
    $submittedFrom: String
  ) {
    submit2FormGetPropertyInfo(
      input: {
        clientMutationId: ""
        uniqueIds: $uniqueIds
        utm: $utm
        submittedFrom: $submittedFrom
      }
    ) {
      status
      message
    }
  }
`

const SocialMediaTemplate = () => {
  const [submitForm, { loading }] = useMutation(SUBMIT_GET_PROPERTY_INFO)

  useEffect(() => {
    const navbar = document.querySelector(".navbar-expand-lg")
    const mainSosmed = document.querySelector(".mainSosmed")
    const navbarWrapp = document.querySelector(".navbar-wrapper")
    const mainAnimated = document.querySelector(".animated")
    const footer = document.querySelector("footer")
    const footertop = document.querySelector(".footer-top")
    const redribbon = document.querySelector(".ribbon.red")
    const blackribbon = document.querySelector(".ribbon.black")
    const blackbottomribbon = document.querySelector(".ribbon.black-bottom")
    const imagefooter = document.querySelector(".red-ribbon .img-fluid")
    navbar.classList.add("d-none")
    navbarWrapp.classList.add("d-none")
    mainAnimated.classList.add("m-0")
    footertop.classList.add("d-none")
    redribbon.classList.add("d-none")
    blackribbon.classList.add("d-none")
    imagefooter.classList.add("d-none")
    // mainSosmed.style.marginBottom = "150px"
    blackbottomribbon.style.backgroundColor = "#f17f21"
    blackbottomribbon.style.height = "90px"
    footer.style.backgroundColor = "#fff !important"
    footer.style.marginTop = "0px !important"

    // Create Element
    const footercurve = document.createElement("div")
    footercurve.setAttribute("id", "footerHalf")
    footer.setAttribute("class", "footer-socmed")
    document.getElementsByClassName("black-bottom")[0].appendChild(footercurve)
  }, [])

  const handleGetPropertyInfo = async () => {
    // 1️⃣ Safari iPhone: buka tab dummy dulu
    const newTab = window.open("about:blank", "_blank")

    const utm = extractSearchParams(window.location.search)
    const utm_content = utm.utm_content || ""

    const utmMapping = {
      Link_Bio_Instagram: {
        source: "Instagram",
        lsn: "CAM-Performance-Development-Button-Get-Property-Information-Instagram-BSD-Website",
      },
      Link_Bio_Tiktok: {
        source: "Tiktok",
        lsn: "CAM-Performance-Development-Button-Get-Property-Information-Tiktok-BSD-Website",
      },
      Link_Bio_Facebook: {
        source: "Facebook",
        lsn: "CAM-Performance-Development-Button-Get-Property-Information-Facebook-BSD-Website",
      },
      Link_Bio_Youtube: {
        source: "Youtube",
        lsn: "CAM-Performance-Development-Button-Get-Property-Information-Youtube-BSD-Website",
      },
      Link_Bio_X: {
        source: "X",
        lsn: "CAM-Performance-Development-Button-Get-Property-Information-X-BSD-Website",
      },
    }

    const config = utmMapping[utm_content] || {
      source: "BSDWebsite",
      lsn: "CAM-Performance-Development-Button-Get-Property-Information-BSD-Website",
    }

    const { source, lsn } = config

    try {
      const ipAddress = await getIpAddress()
      const uniqueId = hashIP(ipAddress)

      const message = `${source}, LSN: ${lsn}

        Hi, saya ingin mendapatkan informasi seputar produk dari BSD City. 

        Saya dengan: 

        Terima kasih!`

      const whatsappUrl =
        "https://api.whatsapp.com/send/?phone=628811382862&text=" +
        encodeURIComponent(message)

      submitForm({
        variables: {
          uniqueIds: uniqueId,
          utm: JSON.stringify(extractSearchParams(window.location.search)),
          submittedFrom: "socialmedia - Get Property Info",
        },
      }).then((res) => {
        console.log("res", res)
        if (res.data.submit2FormGetPropertyInfo.status === "success") {
          // 3️⃣ Cek newTab bukan null sebelum assign
          if (newTab) {
            newTab.location.href = whatsappUrl
          } else {
            // fallback jika Safari mem-block popup
            window.location.href = whatsappUrl
          }
        }
      })
    } catch (err) {
      console.error("❌ ERROR:", err)

      // Tutup tab jika gagal
      if (newTab) newTab.close()
    }
  }

  return (
    <Layout>
      <SEO title="Social Media" />
      <Section className="bg-light lineupSosmed">&nbsp;</Section>
      <Section className="bg-light mainSosmed">
        <Container className="text-center">
          <div className="mb-4">
            <a href="/">
              <img src={logoBrand} className="logoBrand" />
            </a>
          </div>
        </Container>
        <div className="text-center">
          <div className="mb-4">Follow Our Social Media</div>
          <div
            className="mb-4 mw-100 d-inline-flex"
            style={{ overflow: "auto hidden" }}
          >
            <div>
              <a
                href="https://www.facebook.com/bsdcity01"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={fbCircle} />
              </a>
            </div>
            <div>
              <a
                href="https://twitter.com/BsdCity_"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={twCircle} />
              </a>
            </div>
            <div>
              <a
                href="https://www.instagram.com/bsdcity_official/"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={igCircle} />
              </a>
            </div>
            <div>
              <a
                href="https://www.youtube.com/channel/UCROqxpuae_WdYBgpb-DoYFQ?sub_confirmation=1"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={youtubeCircle} />
              </a>
            </div>
            <div>
              <a
                href="https://www.tiktok.com/@bsdcity_official?"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={linkedinCircle} />
              </a>
            </div>
            <div>
              <a
                href="https://sinarmasland.com/career?utm_source=Social_Media&utm_medium=FBIGOrganic&utm_campaign=Digital_WFH_2021&utm_content=Linktree_IG_BSD_Career"
                className="circleIcon"
                target="_blank"
              >
                <img className="circle" src={cooperCircle} />
              </a>
            </div>
          </div>
        </div>
        <Container>
          <div className="text-center" style={{ padding: "15px" }}>
            More Information:{" "}
          </div>
          <div className="row btnLine">
            {/* <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://www.sinarmasland.com/move-in-quickly/"
                  target="_blank"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img
                        src={icMIQ}
                        style={{
                          width: "auto",
                          height: "30px",
                        }}
                      />
                    </div>
                    <div className="desc">Move In Quickly</div>
                  </div>
                </a>
              </div>
            </div> */}
            <div className="col-md-4">
              <div class="btn-rounded">
                <button
                  onClick={() => handleGetPropertyInfo()}
                  className="p-0 w-100 border-0 bg-transparent"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img src={waIcon} />
                    </div>
                    <div className="desc">Get Property Information</div>
                  </div>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://www.bsdcity.com/news-events/blog"
                  target="_self"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        viewBox="0 0 2048 1408"
                      >
                        <path
                          fill="#2d3091"
                          d="M1024 384H640v384h384zm128 640v128H512v-128zm0-768v640H512V256zm640 768v128h-512v-128zm0-256v128h-512V768zm0-256v128h-512V512zm0-256v128h-512V256zM256 1216V256H128v960q0 26 19 45t45 19t45-19t19-45m1664 0V128H384v1088q0 33-11 64h1483q26 0 45-19t19-45M2048 0v1216q0 80-56 136t-136 56H192q-80 0-136-56T0 1216V128h256V0z"
                        />
                      </svg>
                    </div>
                    <div className="desc">Blog</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://bsdcity.com/sustainability?utm_source=Social_Media&utm_medium=FBIGOrganic&utm_campaign=Digital_WFH_2021&utm_content=Linktree_IG_BSD_Sustainability"
                  target="_blank"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img src={icSuistainability} />
                    </div>
                    <div className="desc">Sustainability</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div className="row btnLine">
            <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://bsdcity.com/development/residential?utm_source=Social_Media&utm_medium=FBIGOrganic&utm_campaign=Digital_WFH_2021&utm_content=Linktree_IG_BSD_Development"
                  target="_blank"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img src={icHome} />
                    </div>
                    <div className="desc">Residential</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://api.whatsapp.com/send/?phone=628816888000&text=Halo%20SILVIA%2C%20saya%20ingin%20dibantu%20seputar%20layanan%20Sinar%20Mas%20Land%20Customer%20Care.%0A%0ATerima%20kasih%21"
                  target="_blank"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img src={csIcon} />
                    </div>
                    <div className="desc">Customer Care</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div class="btn-rounded">
                <a
                  href="https://www.sinarmasland.com/precious/"
                  target="_blank"
                >
                  <div className="lineUp">
                    <div className="icon">
                      <img src={icGlobe} />
                    </div>
                    <div className="desc">Sinar Mas Land Precious</div>
                  </div>
                </a>
              </div>
            </div>
          </div>
          {/* <div className="row col-md-12 btnLine">
            <div className="col-md-4">
              <div class="btn-rounded">
                <a href="https://wa.me/628811382862" target="_blank">
                  <div className="lineUp">
                    <div className="icon"><img src={waIcon}/></div>
                    <div className="desc">WA Telemarketing</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-md-4">
              <div class="btn-rounded">
                <a href="https://www.bsdcity.com/contact-us/" target="_blank">
                  <div className="lineUp">
                    <div className="icon"><img src={csIcon}/></div>
                    <div className="desc">Contact Us</div>
                  </div>
                </a>
              </div>
            </div>
          </div> */}
        </Container>
      </Section>
    </Layout>
  )
}

export default SocialMediaTemplate
